import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { getService } from "@/modules/order/services";
import { IService } from "@/modules/serviceOrdering/reducers";

import Loader from "../../../common/components/Loader.tsx";
import ServiceReportDiagnosticFrom from "../components/ServiceReportDiagnosticFrom.tsx";


interface RouteParams {
  id: string;
}

const ServiceReportDiagnosticFromContainer = () => {
  const { id } = useParams<RouteParams>();

  const { data, isLoading, error } = useQuery<IService, Error>(
    ["service", id],
    () => getService(id),
    {
      enabled: !!id,
      staleTime: Infinity,
    },
  );

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return (
      <div className="bg-container">
        <Alert variant="danger">Erreur chargement des données : {error}</Alert>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-container">
        <Alert variant="danger">
          Erreur de récupération des données :<br />
          Veuillez réessayer ultérieurement.
        </Alert>
      </div>
    );
  }

  return <ServiceReportDiagnosticFrom data={data} id={id} />;
};

export default ServiceReportDiagnosticFromContainer;
